import React from 'react';

import PropTypes from 'prop-types';
import { TextArea } from '@telus-uds/components-web';

import { useLocaleContext } from '../../../context/LocaleContext';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const DefectErrorMessage = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const locale = useLocaleContext();
  const {
    reportIssue: {
      form: {
        Max_200_Characters: max200Characters,
        labelErrorMessage,
        placeHolderErrorMessage
      }
    }
  } = locale === 'en-US' ? EN : FR;

  return (
    <div>
      <TextArea
        label={`${labelErrorMessage} *`}
        hint={max200Characters}
        value={fieldData.errorMessage}
        placeholder={placeHolderErrorMessage}
        feedback={
          'errorMessage' in formErrors
            ? formErrors.errorMessage.message
            : ''
        }
        validation={'errorMessage' in formErrors ? 'error' : undefined}
        onChange={(value) => {
          if (!value)
            setFormErrors({
              ...formErrors,
              errorMessage: { message: 'Field is required' }
            });
          else if (value.length > 200)
            setFormErrors({
              ...formErrors,
              errorMessage: { message: 'Maximum 200 characters allowed' }
            });
          else {
            const errors = { ...formErrors };
            delete errors.errorMessage;
            setFormErrors({
              ...errors
            });
          }
          setFieldData(previousValue => ({
            ...previousValue,
            errorMessage: value
          }));
        }}
      />
    </div>
  );
};

DefectErrorMessage.propTypes = {
  formErrors: PropTypes.shape({
    errorMessage: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    issueSummary: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.string
  }).isRequired
};

export default DefectErrorMessage;
